import { Base } from '../base-component';
import './logo-carousel-item.component.scss';

export class LogoCarouselItem extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/logo-carousel-item/logo-carousel-item.component.ts